import {
  type dtoSTCfinderFilterResults,
  type dtoSTCfinderMountData,
  type STCfinderMountData,
  type TypeSTCfinderFilterResults,
} from "~/pages/StcFinderPage/types";

export const transformResults = (dto: dtoSTCfinderFilterResults): TypeSTCfinderFilterResults => {
  const transformedResults = (dto.results ?? []).map((dtoResult) => {
    return {
      name: dtoResult.name ?? "-",
      phoneNumber: dtoResult.phoneNo ?? "-",
      email: dtoResult.contactEmail ?? dtoResult.elementEmail ?? "-",
      street: dtoResult.fullAddress ?? "-",
      city: dtoResult.city ?? "-",
      zipCode: dtoResult.pincode ?? "-",
      state: dtoResult.state ?? "-",
      country: dtoResult.country ?? "-",
    };
  });
  const transformedStates = (dto.states ?? []).map((dtoSate) => {
    return {
      value: dtoSate.isocode,
      label: "",
      stringLabel: dtoSate.name,
    };
  });
  return {
    results: transformedResults,
    states: transformedStates,
  };
};

export const transformMountData = (dto: dtoSTCfinderMountData): STCfinderMountData => {
  const transformedCountries = dto.countries.map((country) => ({
    value: country.isocode,
    label: "",
    stringLabel: country.name,
  }));

  return {
    countries: transformedCountries,
    pageCode: dto.country,
  };
};
